module.exports = "/_next/static/images/638c9054ee1d9e06e4ea990399aff68e-mulher-com-cachos-maravilhosos-segurando-cartao-md@3x.jpg";